const Pace        = require('pace/pace.js');
const ParseLatest = require('parse/build/parse-latest.js');

// load pace before parse since it modifies xmlhttprequest
Pace.start({
    document: true,
    ajax: {
        trackMethods: ['GET', 'POST'],
    },
});

module.exports = ParseLatest.Parse;



// WEBPACK FOOTER //
// ./app/parse.js